import {Injectable} from '@angular/core';
import {CoreService, LogisticsService, ProleisObject, ScannerService,} from 'proleis-rest-client';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {LogisticsActions} from './logistics.index';
import {exhaustMap, map, tap} from 'rxjs/operators';
import {RedirectService} from '../../general/services/redirect.service';
import {NotificationService} from '../../../p4m/notification.service';

@Injectable()
export class LogisticsEffects {
  constructor(
    private cs: CoreService,
    private actions: Actions,
    private rs: RedirectService,
    private ns: NotificationService,
    private scannerService: ScannerService,
    private ls: LogisticsService
  ) {
  }

  scanObject$ = createEffect(() => {
    return this.actions.pipe(
      ofType(LogisticsActions.scanObject),
      exhaustMap((action) => {
        const objectId = Number(action.scanCode);
        if (isNaN(objectId)) {
          return this.scannerService
            .executeScan(action.scanCode)
            .pipe(
              map((result) =>
                LogisticsActions.onScanSequenceSuccess({result}),
              ),
            );
        }
        return this.cs
          .getObjectById<ProleisObject>(action.scanCode)
          .pipe(
            map((scannedObject) =>
              LogisticsActions.onScanObjectSuccess({object: scannedObject}),
            ),
          );

      }),
    );
  });

  onScanObjectSuccess$ = createEffect(
    () => {
      return this.actions.pipe(
        ofType(LogisticsActions.onScanObjectSuccess),
        tap((action) => this.rs.redirectToInfoPanel(action.object.OBJECT_ID)),
      );
    },
    {
      dispatch: false,
    },
  );

  relocate$ = createEffect(() => {
    return this.actions.pipe(
      ofType(LogisticsActions.relocate),
      exhaustMap((action) => {
        return this.ls.relocateStorage(action.sourceId, action.targetId).pipe(
          map(() => LogisticsActions.onRelocateSuccess())
        )
      }),
    );
  });

  onRelocateSuccess$ = createEffect(
    () => {
      return this.actions.pipe(
        ofType(LogisticsActions.onRelocateSuccess),
        tap(() =>
          this.ns.showNotification('Lagerinhalt umgebucht!', 'success'),
        ),
      );
    },
    {dispatch: false},
  );

  update$ = createEffect(() => {
    return this.actions.pipe(
      ofType(LogisticsActions.updateLogistics),
      exhaustMap((action) => {
        return this.ls.assignPositionsToStorage(action.storageId, action.posIds).pipe(
          map(() => LogisticsActions.onUpdateLogisticsSuccess()),
        )
      }),
    );
  });

  onUpdateSuccess$ = createEffect(
    () => {
      return this.actions.pipe(
        ofType(LogisticsActions.onUpdateLogisticsSuccess),
        tap(() =>
          this.ns.showNotification('Logistik Update erfolgreich!', 'success'),
        ),
      );
    },
    {dispatch: false},
  );

  createTransport$ = createEffect(() => {
    return this.actions.pipe(
      ofType(LogisticsActions.createTransport),
      exhaustMap((action) => {
        return this.ls.createTransport(action.storageId, action.posId).pipe(
          map(() => LogisticsActions.onCreateTransportSuccess()),
        )
      }),
    );
  });

  onCreateTransportSuccess$ = createEffect(
    () => {
      return this.actions.pipe(
        ofType(LogisticsActions.onCreateTransportSuccess),
        tap(() =>
          this.ns.showNotification('Transportauftrag angelegt!', 'success'),
        ),
      );
    },
    {dispatch: false},
  );
}
